export function parseLocation(jsonStr) {
    // console.log("parse location", jsonStr);
    try {
        const jsonObj = JSON.parse(jsonStr);
        const latitude = jsonObj['latitude'];
        const longitude = jsonObj['longitude'];
        const heading = jsonObj['heading'];

        const positionQualityString = jsonObj['position_quality'];
        const positionQuality = positionQualityString === "good" ? 2 : positionQualityString === "degraded" ? 1 : 0;

        const headingQualityString = jsonObj['heading_quality'];
        const headingQuality = headingQualityString === "good" ? 2 : headingQualityString === "degraded" ? 1 : 0;

        const positionFixString = jsonObj['position_fix']; // no_fix, rtk_fix, autonomous_gnss_fix, differential_gnss_fix
        const positionFix = positionFixString === "rtk_fix" ? "RTK fix" : positionFixString === "rtk_float" ? "RTK float" : "no fix";

        return {latitude, longitude, heading, headingQuality, positionQuality, positionFix};
    } catch (err) {
        console.error('Invalid JSON:', err);
        return null;
    }
}

export function parseStatus(jsonStr) {
    try {
        return {'status': parseInt(jsonStr)};
    } catch (err) {
        console.error('Invalid JSON:', err);
        return {'status': 0};
    }
}

export function parseNavigationSkill(jsonStr) {
  try {
      const jsonObj = JSON.parse(jsonStr);
      const status = jsonObj["status"];
      const activateAutonomy = jsonObj["activate_autonomy"];
      const identifier = jsonObj["identifier"];
      const progress = jsonObj["progress"];
      const isReady = status === "ready";
      const hasError = status === "error";
      const isPlayback = status === "playback";
      const isMachineActive = status === "active";
      const isFinished = status === "finished";
      const isManual = status === "manual";
      const isDependency = status === "dependency";
      const isOperatorRequired = status === "operator_required";
      return {status, activateAutonomy, identifier, progress, isReady, hasError, isPlayback, isMachineActive, isFinished, isManual, isDependency, isOperatorRequired};
  } catch (err) {
      console.error('Invalid JSON:', err);
      return null;
  }
}

export function parseWorkConfiguration(jsonStr) {
    try {
        const jsonObj = JSON.parse(jsonStr);
        const selectedParcel = jsonObj["selected_parcel"];
        if (selectedParcel) {
            const fieldName = selectedParcel["field_name"];
            if (fieldName && fieldName.length > 0) {
                // console.error("PARSER", fieldName);
                return fieldName;
            }
        }
        return undefined;
    } catch (err) {
        console.error('Invalid JSON:', err);
        return undefined;
    }
}